import { render, staticRenderFns } from "./Visitors.vue?vue&type=template&id=bc800d4c&scoped=true&"
import script from "./Visitors.vue?vue&type=script&lang=js&"
export * from "./Visitors.vue?vue&type=script&lang=js&"
import style0 from "./Visitors.vue?vue&type=style&index=0&id=bc800d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc800d4c",
  null
  
)

export default component.exports